import React from 'react';

// === Components === //
import Container from '@components/common/Container';
import ButtonLink from '@components/common/ButtonLink';

// === Content === //
import iconFacebookBlue from '@assets/svg/icon_facebook_blue.svg';
import iconLinkedInBlue from '@assets/svg/icon_linkedin_blue.svg';
import iconInstagramBlue from '@assets/svg/icon_instagram_blue.svg';
import iconXingBlue from '@assets/svg/XING_patients.svg';
import iconYoutubeBlue from '@assets/svg/YT_patients.svg';
import iconFacebookRed from '@assets/svg/icon_facebook_red.svg';
import iconLinkedInRed from '@assets/svg/icon_linkedin_red.svg';
import iconInstagramRed from '@assets/svg/icon_instagram_red.svg';
import iconXingRed from '@assets/svg/XING_hcp.svg';
import iconYoutubeRed from '@assets/svg/YT_hcp.svg';
import iconTwitterBlue from '@assets/svg/icon_twitter_blue.svg';
import iconTwitterRed from '@assets/svg/icon_twitter_red.svg';

// === Styles === //
import styled from '@emotion/styled';
import { breakpoints, mixins, respondFrom } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { css } from '@emotion/react';

const SocialMediaWrapper = styled.div`
  display: flex;
  flex-flow: column;

  a {
    margin-bottom: 0;
  }

  ${respondFrom(
    breakpoints.md,
    css`
      flex-flow: row;
      align-items: center;
    `
  )}
`;

const SocialIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: -12px;

  ${respondFrom(
    breakpoints.md,
    css`
      margin-top: 0;
      margin-left: 12px;
    `
  )}
`;

const Icon = styled.div`
  ${mixins.transitionDefault};

  > a {
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

interface SocialMediaProps {
  facebookLink: string;
  instagramLink: string;
  linkedinLink: string;
  xingLink: string;
  youtubeLink: string;
  twitterLink: string;
  button: SocialMediaButton;
  variant: Variant;
}

interface SocialMediaButton {
  url: string;
  label: string;
}

const SocialMedia = ({
  facebookLink,
  instagramLink,
  linkedinLink,
  xingLink,
  youtubeLink,
  twitterLink,
  button,
  variant,
}: SocialMediaProps) => {
  return (
    <Container>
      <SocialMediaWrapper>
        <div>
          <ButtonLink type="external" variant={variant} link={button.url} icon="external_link">
            {button.label}
          </ButtonLink>
        </div>
        <SocialIconsWrapper>
          {instagramLink && instagramLink !== '' && (
            <Icon>
              <a href={instagramLink} target="_blank">
                <img src={variant === 'blue' ? iconInstagramBlue : iconInstagramRed} />
              </a>
            </Icon>
          )}
          {linkedinLink && linkedinLink !== '' && (
            <Icon>
              <a href={linkedinLink} target="_blank">
                <img src={variant === 'blue' ? iconLinkedInBlue : iconLinkedInRed} />
              </a>
            </Icon>
          )}
          {facebookLink && facebookLink !== '' && (
            <Icon>
              <a href={facebookLink} target="_blank">
                <img src={variant === 'blue' ? iconFacebookBlue : iconFacebookRed} />
              </a>
            </Icon>
          )}
          {xingLink && xingLink !== '' && (
            <Icon>
              <a href={xingLink} target="_blank">
                <img src={variant === 'blue' ? iconXingBlue : iconXingRed} />
              </a>
            </Icon>
          )}
          {youtubeLink && youtubeLink !== '' && (
            <Icon>
              <a href={youtubeLink} target="_blank">
                <img src={variant === 'blue' ? iconYoutubeBlue : iconYoutubeRed} />
              </a>
            </Icon>
          )}
          {twitterLink && twitterLink !== '' && (
            <Icon>
              <a href={twitterLink} target="_blank">
                <img src={variant === 'blue' ? iconTwitterBlue : iconTwitterRed} />
              </a>
            </Icon>
          )}
        </SocialIconsWrapper>
      </SocialMediaWrapper>
    </Container>
  );
};

export default SocialMedia;
